/**
 * Non-disclosure agreement endpoints.
 *
 * Both are exempt from the server's NDA gate — necessarily, since the gate cannot stand in front
 * of the only way through it. They are therefore the only two calls an un-accepted account can
 * make that will not come back 403.
 */

import apiClient from '../client'
import type { NdaStatus, NdaAcceptResponse } from '../types/nda'

/** Query key for the current agreement. Shared so the gate and the accept flow invalidate the same entry. */
export const NDA_CURRENT_QUERY_KEY = ['nda', 'current'] as const

/**
 * The agreement in force, and whether this user has accepted it.
 * GET /api/nda/current
 */
export const getCurrentNda = async (): Promise<NdaStatus> => {
  const response = await apiClient.get<NdaStatus>('/api/nda/current')
  return response.data
}

/**
 * Record acceptance of the version that was shown.
 * POST /api/nda/accept
 *
 * The version is sent rather than assumed: if the text has been republished since this copy was
 * loaded the server answers 409 `nda_version_stale` instead of recording a signature against
 * words the user never read. Callers must handle that by reloading the document and asking again.
 */
export const acceptNda = async (version: number): Promise<NdaAcceptResponse> => {
  const response = await apiClient.post<NdaAcceptResponse>('/api/nda/accept', { version })
  return response.data
}
